import { render } from "./GlobalLoadingSpinner.vue?vue&type=template&id=60bc140a&scoped=true"
import script from "./GlobalLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./GlobalLoadingSpinner.vue?vue&type=script&lang=js"

import "./GlobalLoadingSpinner.vue?vue&type=style&index=0&id=60bc140a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bc140a"]])

export default __exports__